/* unplugin-vue-components disabled */import { render } from "./audit.vue?vue&type=template&id=5cd0b5ea&scoped=true"
import script from "./audit.vue?vue&type=script&setup=true&lang=js"
export * from "./audit.vue?vue&type=script&setup=true&lang=js"

import "./audit.vue?vue&type=style&index=0&id=5cd0b5ea&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd0b5ea"],['__file',"src/pages/settings/superuser/audit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cd0b5ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cd0b5ea', __exports__)) {
    api.reload('5cd0b5ea', __exports__)
  }
  
  module.hot.accept("./audit.vue?vue&type=template&id=5cd0b5ea&scoped=true", () => {
    api.rerender('5cd0b5ea', render)
  })

}


export default __exports__